/**
 * Component: Shop The Look Popup
 * ------------------------------------------------------------------------------
 * - A popup made to house the 'Shop The Look' component
 * - Original component would render a popup in HTML/Liquid for every instance of STL
 * - Refactored to dynamically inject HTML element to be more performant
 * - MT-471 is a 2023 ticket to Vue-ify this component and support better on-demand rendering.
 *
 * @namespace Popup
 */
import ShopTheLook from '~/components/shop-the-look'

const Popup = (() => {

  const ACTIVE_CLASS = 'visible'

  const selectors = {
    activePopup: `.${ACTIVE_CLASS}[js-shop-the-look-popup]`,
    closePopup: '[data-close-popup]',
    openPopup: '[data-open-popup]',
  }

  const nodeSelectors = {
    openPopup: [...document.querySelectorAll(selectors.openPopup)],
  }

  let scrollPosition = 0

  function bodyLock() {
    scrollPosition = window.pageYOffset
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollPosition}px`
    document.body.style.width = '100%'
  }

  function bodyUnlock() {
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('position')
    document.body.style.removeProperty('top')
    document.body.style.removeProperty('width')
  }

  function eventListeners() {
    document.body.addEventListener('click', (_event) => {
      const openPopup = _event.target.closest(selectors.openPopup)
      if (openPopup) {
        _event.stopPropagation()
        _event.preventDefault()

        const popupId = openPopup.dataset.openPopup
        const popupTemplate = document.querySelector(`[js-stl-popup-template="${popupId}"]`)

        if (!popupTemplate) {
          return
        }

        document.body.insertAdjacentHTML('beforeend', popupTemplate.innerHTML)

        const popup = document.querySelector(`#${popupId}`)

        if (!popup) {
          return
        }

        /**
          * Initialise existing STL component for this one pop-up
          */
        ShopTheLook.init()

        /**
          * Initialise:
          * - Slick carousel using theme methods
          * - Wishlist button via Swym SDK
          */
        const popupCarouseljQuery = window.$(`#${popupId}`).find('[data-slick]')

        popupCarouseljQuery.slick()

        /**
         * Note: This function appears to be deprecated, as it is not listed in
         * the Swym documentation.
         */
        MintSwat.initializeActionButtons(`#${popupId}`)

        /**
          * Add active states per popups existing functionality.
          */
        popup.classList.add(ACTIVE_CLASS)
        popup.dataset.lock == 'true' ? bodyLock() : bodyUnlock()

        const closeButtons = popup.querySelectorAll(selectors.closePopup)

        /**
          * Handle close (for close buttons and overlay).
          * - Remove active states
          * - Remove slick
          * - Remove element
          */
        closeButtons.forEach(closeButton => {
          closeButton.addEventListener('click', (_event) => {
            _event.stopPropagation()
            _event.preventDefault()

            const popup = document.querySelector(`#${popupId}`)

            if (!popup) {
              return
            }

            popup.classList.remove(ACTIVE_CLASS)
            popup.dataset.lock == 'true' ? bodyUnlock() : ''
            popup.remove()
          })
        })
      }
    })

  }

  function setEventBusListeners() {

    /**
     * Initiate actions to open the 'Notify me' back in stock modal.
     * - ES6 components can use the EventBus, as below
     * - Vue components should use Pinia, which will also emit a mock event.
     */
    mint.EventBus.on('wishlist:addToWatchlist', (payload) => {
      const activePopup = document.querySelector(selectors.activePopup)

      if (!activePopup) {
        return
      }

      activePopup.classList.remove(ACTIVE_CLASS)
      activePopup.dataset.lock == 'true' ? bodyUnlock() : ''
      activePopup.remove()
    })
  }

  /**
    * Emit an event to GA on page view.
    * Send a Google Analytics 'Page View' event if:
    * - The current page type is that of a 'Page'
    * - The current page has at least one 'Shop The Look' popup present.
    * - The page has not already fired a 'Page View' event.
    */
  function sendGoogleEvent() {
    if (
      (mint.request.pageType !== 'page') ||
       (mint.request.pageType === 'page' && !nodeSelectors.openPopup.length)
    ) {
      return
    }

    const pageTitle = document.title
    const pageLocation = location.href
    const pagePath = location.href.split('pages')[1]

    gtag('event', 'page_view', {
      page_location: `${pageLocation}`,
      page_path: `${pagePath}`,
      page_title: `${pageTitle}`,
    })
  }

  /**
    * Initialise component.
    */
  function init() {
    sendGoogleEvent()
    eventListeners()
    setEventBusListeners()
  }

  /**
    * Expose public interface.
    */
  return {
    init,
  }
})()

export default Popup
